module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//27.jpg?b8a26f45c7542b711e61363d0f992439";